const FirstIcon: React.FC = () => {
    return (
        <svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.563719 0C0.875053 -1.30133e-08 1.12744 0.27151 1.12744 0.606436L1.12744 20.3936C1.12744 20.7285 0.875054 21 0.56372 21C0.252387 21 9.13806e-07 20.7285 8.98596e-07 20.3936L0 0.606436C-1.52099e-08 0.271511 0.252386 1.30133e-08 0.563719 0Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.8726 19.1838L15.8726 2.16249L2.92699 10.6731L15.8726 19.1838ZM17 19.6163C17 20.374 16.2287 20.8394 15.6277 20.4443L2.02424 11.5011C1.44873 11.1227 1.44873 10.2236 2.02424 9.84521L15.6277 0.902031C16.2287 0.506912 17 0.972236 17 1.72997V19.6163Z"
                fill="white"
            />
        </svg>
    )
}

FirstIcon.displayName = 'FirstIcon'

export default FirstIcon
